import {CREATE_PROJECT_SUCCESS} from "../../reducers/createProjectReducer";


export const createProjectSuccess = (project) =>{
    return {
        type: CREATE_PROJECT_SUCCESS,
        payload: {project}
    }
}